<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-29 15:11:38
-->
<template>
  <div class="app-container">
    <div class="title">专员详情</div>
    <section class="content">
      <section class="information">
        <div class="title">
          <span></span>
          专员信息
        </div>
        <div class="message">
          <div>
            姓名：<span>{{ user.name || '-' }}</span>
          </div>
          <div>
            用户名：<span>{{ user.username || '-' }}</span>
          </div>
          <div>
            所属区域：<span
              >浙江省 丽水市 {{ user.departmentText || '-' }}</span
            >
          </div>
        </div>
        <div class="message">
          <div>
            职能部门：<span>{{ user.position || '-' }}</span>
          </div>
          <div>
            联系方式：<span>{{ user.mobile || '-' }}</span>
          </div>
          <div>
            邮箱：<span>{{ user.mail || '-' }}</span>
          </div>
        </div>
      </section>
      <section class="enterprise">
        <div class="title">
          <span></span>专员管理的企业
          <el-button
            type="primary"
            size="small"
            @click="add()"
            style="float: right"
            >添加企业</el-button
          >
        </div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa' }"
          height="350"
        >
          <el-table-column
            prop="entName"
            label="企业名称"
            align="center"
            width="250"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="creditCode"
            align="center"
            label="统一社会信用代码"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="frName"
            label="法人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="address"
            label="注册地址"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #1890ff"
                @click="deleteEntTrain(scope.row.commerId)"
                >解除绑定</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="totalRecord"
          >
          </el-pagination>
        </div>
      </section>
      <section class="visit">
        <div class="title"><span></span>专员走访</div>
        <el-table
          :data="tableData1"
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa' }"
          height="350"
        >
          <el-table-column
            prop="commerTitle"
            label="走访事由"
            align="center"
            width="250"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="commerType"
            align="center"
            label="发起人"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ commerStatus(scope.row.commerType) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="entName"
            label="企业名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="commerStatusStr"
            label="状态"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #1890ff"
                @click="onGovisit(scope.row.id)"
                >查看</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="currentPage1"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :page-size="pageSize1"
            :total="totalRecord1"
          >
          </el-pagination>
        </div>
      </section>
    </section>
    <el-dialog
      title="联系企业"
      :visible.sync="dialogVisible"
      width="50%"
      @closed="handleClose"
    >
      <div>
        <el-form
          :model="message"
          ref="message"
          label-width="0"
          label-position="left"
          :rules="rules"
        >
          <el-form-item label="" prop="">
            <el-input
              v-model="message.searchKey"
              placeholder="请输入企业名称"
              @keyup.enter.native="getPoss"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getPoss"
              ></el-button
            ></el-input>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData2"
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa' }"
          height="350"
        >
          <el-table-column
            prop="entName"
            label="企业名称"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1"> 已添加 </span>
              <span
                v-else
                style="cursor: pointer; color: #1890ff"
                @click="addEntName(scope.row.creditCode)"
                >添加</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="currentPage2"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :page-size="pageSize2"
            :total="totalRecord2"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCommissionerManagerByPage,
  myListByPage,
  deleteCommerManageaById,
  getEntDataByPage,
  addEntData,
} from '@api/commissionerManagement/commissioner'
import { getArea } from '@api/video/video'
import { getUserDetail } from '@/common/api/organization/user'
import { isHttp, getToken } from '@utils'
export default {
  name: 'Live',
  data() {
    return {
      tableData: [],
      tableData1: [],
      tableData2: [],
      totalRecord: 0,
      totalRecord1: 0,
      totalRecord2: 0,
      pageSize: 10,
      currentPage: 1,
      pageSize1: 10,
      currentPage1: 1,
      pageSize2: 10,
      currentPage2: 1,
      message: {
        searchKey: '',
      },
      user: {
        name: '',
        username: '',
        mail: '',
        mobile: '',
        position: '',
        nickName: '',
        departmentText: '',
      },
      dialogVisible: false,
      rules: {},
    }
  },
  watch: {},
  computed: {
    commerStatus() {
      return (number) => {
        let val
        switch (number) {
          case 1:
            val = '企业'
            break
          case 2:
            val = '专员'
            break
        }
        return val
      }
    },
  },
  created() {
    this.getUserDetail()
  },
  mounted() {
    this.getCommissionerManagerByPage()
    this.myListByPage()
  },
  methods: {
    add() {
      this.dialogVisible = true
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.dialogVisible = false
      this.message.searchKey = ''
      this.tableData2 = []
      this.totalRecord2 = 0
      this.$refs['message'].resetFields()
    },
    addEntName(creditCode) {
      addEntData({
        creditCode: creditCode,
        userId: this.$route.query.userId,
        name: this.$route.query.name
      }).then((res) => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.getEntDataByPage()
          this.getCommissionerManagerByPage()
        } else {
          this.$message.error(res.data.msg || '解除绑定失败')
        }
      })
    },
    deleteEntTrain(id) {
      this.$confirm('是否确定解除绑定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
      }).then(() => {
        deleteCommerManageaById({ commerId: id }).then((res) => {
          if (res.data.code == '0000') {
            this.$message.success(res.data.msg)
            this.currentPage = 1
            this.pageSize = 10
            this.getCommissionerManagerByPage()
          } else {
            this.$message.error(res.data.msg || '解除绑定失败')
          }
        })
      })
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.getCommissionerManagerByPage()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCommissionerManagerByPage()
    },
    //  表格翻页
    handleCurrentChange1(currentPage, e) {
      this.currentPage1 = currentPage
      this.myListByPage()
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.myListByPage()
    },
    //  表格翻页
    handleCurrentChange2(currentPage, e) {
      this.currentPage2 = currentPage
      this.getEntDataByPage()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.getEntDataByPage()
    },
    // 获取用户详情
    getUserDetail() {
      getUserDetail({ userId: this.$route.query.userId }).then((response) => {
        const that = this
        const res = response.data
        if (res.code == '000000') {
          const { user, groups, roles } = res.data
          const {
            name,
            username,
            mail,
            mobile,
            position,
            nickName,
            departmentText,
          } = user
          this.user = {
            ...this.user,
            name,
            username,
            mail,
            mobile,
            position,
            nickName,
            departmentText,
          }
        } else {
          this.$message({
            message: res.mesg,
            type: 'error',
          })
        }
      })
    },
    // 专员管理的企业
    getCommissionerManagerByPage() {
      getCommissionerManagerByPage({
        userId: this.$route.query.userId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        } else {
          this.$message({
            message: res.data.mesg,
            type: 'error',
          })
        }
      })
    },
    // 专员走访
    myListByPage() {
      myListByPage({
        userId: this.$route.query.userId,
        pageNum: this.currentPage1,
        pageSize: this.pageSize1,
      }).then((res) => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData1 = list.results || []
          this.totalRecord1 = list.totalRecord || 0
        } else {
          this.$message({
            message: res.data.mesg,
            type: 'error',
          })
        }
      })
    },
    // 所有类别
    getPoss() {
      this.currentPage2 = 1
      this.getEntDataByPage()
    },
    /** 未关联企业查询 */
    getEntDataByPage() {
      getEntDataByPage({
        userId: this.$route.query.userId,
        pageNum: this.currentPage2,
        pageSize: this.pageSize2,
        searchKey: this.message.searchKey,
      }).then((res) => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData2 = list.results || []
          this.totalRecord2 = list.totalRecord || 0
        } else {
          this.$message({
            message: res.data.mesg,
            type: 'error',
          })
        }
      })
    },
    onGovisit(id) {
      this.$router.push({ name: 'visitDetail', query: { id: id } })
    },
  },
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    height: 500px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.table-page {
  width: 100%;
  text-align: right;
}
.app-container {
  overflow-y: auto;
  & > .title {
    font-size: 18px;
    font-weight: 600;
  }
  & > .content {
    margin-top: 30px;
    & > .information {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      padding: 16px;
      & > .title {
        font-size: 16px;
        line-height: 24px;
        > span {
          vertical-align: middle;
          width: 3px;
          height: 15px;
          margin-right: 4px;
          display: inline-block;
          background: #1890ff;
        }
      }
      & > .message {
        margin-top: 20px;
        display: flex;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        > div {
          width: 300px;
        }
        span {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
    & > .enterprise {
      margin-top: 16px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      padding: 16px;
      & > .title {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
        > span {
          vertical-align: middle;
          width: 3px;
          height: 15px;
          margin-right: 4px;
          display: inline-block;
          background: #1890ff;
        }
      }
    }
    & > .visit {
      margin-top: 16px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      padding: 16px;
      & > .title {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
        > span {
          margin-right: 4px;
          vertical-align: middle;
          width: 3px;
          height: 15px;
          display: inline-block;
          background: #1890ff;
        }
      }
    }
  }
}
</style>
